var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 118 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8434 55.9069L2.48291 80.7524L26.289 130.492L42.4434 138.993L56.7394 129.531L71.0352 138.993L91.8558 128.825L110.996 80.7524L85.5845 54.8338L56.7394 70.2789L26.8434 55.9069Z",
    stroke: "white",
    strokeWidth: 1.88973,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.48291 80.7522L34.1576 80.5371L26.8434 55.9067L2.48291 80.7522Z",
    stroke: "white",
    strokeWidth: 1.88973,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5846 54.8339L49.8347 98.6836L56.7395 70.2789L85.5846 54.8339Z",
    stroke: "white",
    strokeWidth: 1.88973,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0352 138.993L91.8558 128.825L110.996 80.7524L85.5845 54.8338L76.59 101.784L71.0352 138.993Z",
    stroke: "white",
    strokeWidth: 1.88973,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4076 3.46094L73.8632 28.8585L56.4985 49.3293L62.5114 19.6283L95.4076 3.46094Z",
    stroke: "white",
    strokeWidth: 1.88973,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2144 21.1476L55.9372 49.0461L52.8221 31.0617L33.2144 21.1476Z",
    stroke: "white",
    strokeWidth: 1.88973,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2891 130.491L49.8347 98.6835L56.7395 129.531",
    stroke: "white",
    strokeWidth: 1.88973,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8352 98.6836L76.5901 101.784L110.996 80.7528",
    stroke: "white",
    strokeWidth: 1.88973,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M91.856 128.824L76.5901 101.784",
    stroke: "white",
    strokeWidth: 1.88973,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.48291 80.7528L27.1916 101.723L49.8346 98.6836L34.1572 80.5377",
    stroke: "white",
    strokeWidth: 1.88973,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4985 49.3289L38.7649 41.0778L33.2144 21.1475L56.4985 49.3289Z",
    stroke: "white",
    strokeWidth: 1.88973,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4985 49.3289L79.5853 36.7819L95.4076 3.46086L56.4985 49.3289Z",
    stroke: "white",
    strokeWidth: 1.88973,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2099 60.7847C29.2925 60.7847 30.9807 59.0963 30.9807 57.0135C30.9807 54.9309 29.2925 53.2426 27.2099 53.2426C25.127 53.2426 23.439 54.9309 23.439 57.0135C23.439 59.0963 25.127 60.7847 27.2099 60.7847Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.755867,
    strokeMiterlimit: 22.9256
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.907 88.7278C114.15 88.7278 117.589 85.2883 117.589 81.0459C117.589 76.8034 114.15 73.3643 109.907 73.3643C105.665 73.3643 102.225 76.8034 102.225 81.0459C102.225 85.2883 105.665 88.7278 109.907 88.7278Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.755867,
    strokeMiterlimit: 22.9256
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9424 141.256C43.3383 141.256 44.4695 140.125 44.4695 138.729C44.4695 137.334 43.3383 136.202 41.9424 136.202C40.5467 136.202 39.4155 137.334 39.4155 138.729C39.4155 140.125 40.5467 141.256 41.9424 141.256Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.755867,
    strokeMiterlimit: 22.9256
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1571 83.1841C35.6191 83.1841 36.8039 81.9991 36.8039 80.5377C36.8039 79.0757 35.6191 77.8909 34.1571 77.8909C32.6957 77.8909 31.5107 79.0757 31.5107 80.5377C31.5107 81.9991 32.6957 83.1841 34.1571 83.1841Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.755867,
    strokeMiterlimit: 22.9256
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.8351 102.724C52.0666 102.724 53.8754 100.915 53.8754 98.6833C53.8754 96.4519 52.0666 94.6431 49.8351 94.6431C47.6034 94.6431 45.7944 96.4519 45.7944 98.6833C45.7944 100.915 47.6034 102.724 49.8351 102.724Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.755867,
    strokeMiterlimit: 22.9256
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5899 108.235C80.1529 108.235 83.0411 105.347 83.0411 101.784C83.0411 98.2207 80.1529 95.3324 76.5899 95.3324C73.0266 95.3324 70.1382 98.2207 70.1382 101.784C70.1382 105.347 73.0266 108.235 76.5899 108.235Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.755867,
    strokeMiterlimit: 22.9256
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.55485 83.3916C5.01672 83.3916 6.20166 82.2068 6.20166 80.7452C6.20166 79.2833 5.01672 78.0984 3.55485 78.0984C2.09325 78.0984 0.908447 79.2833 0.908447 80.7452C0.908447 82.2068 2.09325 83.3916 3.55485 83.3916Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.755867,
    strokeMiterlimit: 22.9256
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.7395 72.9253C58.2011 72.9253 59.3861 71.7405 59.3861 70.2789C59.3861 68.8174 58.2011 67.6321 56.7395 67.6321C55.2777 67.6321 54.0928 68.8174 54.0928 70.2789C54.0928 71.7405 55.2777 72.9253 56.7395 72.9253Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.755867,
    strokeMiterlimit: 22.9256
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1913 106.386C29.7675 106.386 31.8552 104.299 31.8552 101.722C31.8552 99.1466 29.7675 97.0588 27.1913 97.0588C24.6156 97.0588 22.5273 99.1466 22.5273 101.722C22.5273 104.299 24.6156 106.386 27.1913 106.386Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.755867,
    strokeMiterlimit: 22.9256
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.289 133.138C27.7505 133.138 28.9354 131.953 28.9354 130.491C28.9354 129.03 27.7505 127.845 26.289 127.845C24.827 127.845 23.6421 129.03 23.6421 130.491C23.6421 131.953 24.827 133.138 26.289 133.138Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.755867,
    strokeMiterlimit: 22.9256
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.0353 141.64C72.4972 141.64 73.6821 140.455 73.6821 138.994C73.6821 137.532 72.4972 136.347 71.0353 136.347C69.5737 136.347 68.3889 137.532 68.3889 138.994C68.3889 140.455 69.5737 141.64 71.0353 141.64Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.755867,
    strokeMiterlimit: 22.9256
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.856 132.657C93.9725 132.657 95.6884 130.941 95.6884 128.824C95.6884 126.708 93.9725 124.991 91.856 124.991C89.7391 124.991 88.0232 126.708 88.0232 128.824C88.0232 130.941 89.7391 132.657 91.856 132.657Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.755867,
    strokeMiterlimit: 22.9256
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.5846 58.4971C87.6078 58.4971 89.2476 56.8571 89.2476 54.8339C89.2476 52.8107 87.6078 51.1708 85.5846 51.1708C83.5614 51.1708 81.9214 52.8107 81.9214 54.8339C81.9214 56.8571 83.5614 58.4971 85.5846 58.4971Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.755867,
    strokeMiterlimit: 22.9256
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5111 22.2751C63.9731 22.2751 65.1579 21.0902 65.1579 19.6283C65.1579 18.1667 63.9731 16.9819 62.5111 16.9819C61.0497 16.9819 59.8647 18.1667 59.8647 19.6283C59.8647 21.0902 61.0497 22.2751 62.5111 22.2751Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.755867,
    strokeMiterlimit: 22.9256
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.8222 33.7085C54.2842 33.7085 55.469 32.5236 55.469 31.0617C55.469 29.6001 54.2842 28.4152 52.8222 28.4152C51.3607 28.4152 50.1758 29.6001 50.1758 31.0617C50.1758 32.5236 51.3607 33.7085 52.8222 33.7085Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.755867,
    strokeMiterlimit: 22.9256
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8089 36.2849C71.2703 36.2849 72.4553 35.1001 72.4553 33.6385C72.4553 32.1766 71.2703 30.9917 69.8089 30.9917C68.3469 30.9917 67.1621 32.1766 67.1621 33.6385C67.1621 35.1001 68.3469 36.2849 69.8089 36.2849Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.755867,
    strokeMiterlimit: 22.9256
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2143 23.7939C34.6761 23.7939 35.8611 22.6092 35.8611 21.1472C35.8611 19.6857 34.6761 18.5008 33.2143 18.5008C31.7527 18.5008 30.5679 19.6857 30.5679 21.1472C30.5679 22.6092 31.7527 23.7939 33.2143 23.7939Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.755867,
    strokeMiterlimit: 22.9256
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7652 43.7244C40.2268 43.7244 41.4116 42.5394 41.4116 41.078C41.4116 39.616 40.2268 38.4312 38.7652 38.4312C37.3034 38.4312 36.1184 39.616 36.1184 41.078C36.1184 42.5394 37.3034 43.7244 38.7652 43.7244Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.755867,
    strokeMiterlimit: 22.9256
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.5854 39.4285C81.0474 39.4285 82.2322 38.2437 82.2322 36.7817C82.2322 35.3202 81.0474 34.1353 79.5854 34.1353C78.1239 34.1353 76.939 35.3202 76.939 36.7817C76.939 38.2437 78.1239 39.4285 79.5854 39.4285Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.755867,
    strokeMiterlimit: 22.9256
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.408 6.10742C96.8696 6.10742 98.0544 4.92262 98.0544 3.46102C98.0544 1.99915 96.8696 0.814209 95.408 0.814209C93.9462 0.814209 92.7612 1.99915 92.7612 3.46102C92.7612 4.92262 93.9462 6.10742 95.408 6.10742Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.755867,
    strokeMiterlimit: 22.9256
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.937 52.4971C57.8431 52.4971 59.3882 50.9524 59.3882 49.0463C59.3882 47.1403 57.8431 45.5952 55.937 45.5952C54.0314 45.5952 52.4863 47.1403 52.4863 49.0463C52.4863 50.9524 54.0314 52.4971 55.937 52.4971Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.755867,
    strokeMiterlimit: 22.9256
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8088 33.6387L62.5112 19.6284",
    stroke: "white",
    strokeWidth: 1.88973,
    strokeMiterlimit: 22.9256
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5852 36.7817L69.8088 33.6387",
    stroke: "white",
    strokeWidth: 1.88973,
    strokeMiterlimit: 22.9256
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2891 130.492L27.1916 101.723",
    stroke: "white",
    strokeWidth: 1.88973,
    strokeMiterlimit: 22.9256
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M26.833 101.606L33.8512 80.2624L56.5846 69.9349L56.8946 70.6228L34.4642 80.8124L27.5504 101.839L26.833 101.606Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.f1e85358.svg";
export { ForwardRef as ReactComponent };